import { Box, TableCell, Typography } from '@mui/material';
import { ViewLink } from '.';
import { Report } from '@mui/icons-material';

type TypeProps = {
  entries: [string, string][];
  partners?: { label: string; id: string }[];
  isMultiplePartners: boolean;
  isAuditOfInterest: boolean;
  sessionId: string;
  isView: boolean;
  pathname: string;
  closeModal: () => void;
};

export const UserCell = ({
  sessionId,
  isAuditOfInterest,
  partners,
  isMultiplePartners,
  entries,
  isView,
  pathname,
  closeModal,
}: TypeProps) => {
  const to = `/instructor/audit/${sessionId}`;
  const onClose = pathname === to ? closeModal : () => null;

  return (
    <>
      {entries.map((entry) => {
        const [keyName, value] = entry;
        const isSessionStatus = keyName === 'sessionStatus';
        const isPartnerUuid = keyName === 'partnerUuid';
        return (
          <TableCell key={keyName} size='small'>
            {isSessionStatus && isAuditOfInterest ? (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography component='span' variant='tableCell'>
                  {value}
                </Typography>
                <Report color='error' />
              </Box>
            ) : isMultiplePartners && isPartnerUuid && partners ? (
              <Typography variant='tableCell'>
                {partners.find(({ id }) => id === value)?.label}
              </Typography>
            ) : (
              <Typography variant='tableCell'>{value}</Typography>
            )}
          </TableCell>
        );
      })}
      {isView && <ViewLink to={to} onClick={onClose} />}
    </>
  );
};
